// extracted by mini-css-extract-plugin
export var lightMode = "_1j-0";